import { useCallback } from 'react'
import axios from 'axios'

import { NavigationAction, NavigationEvent } from '@/types/api/events'

export const useNavigationTracking = () => {
  const isLocalhost =
    typeof window !== 'undefined' && window.location.hostname === 'localhost'

  const trackNavigationEvent = useCallback(
    async (action: NavigationAction, linkName?: string) => {
      if (isLocalhost) {
        return
      }

      try {
        const event: NavigationEvent = {
          eventType: 'click',
          objectType: `NAVIGATION_MENU`,
          objectName: `${linkName}_${action}` || 'unknown',
          timestamp: new Date().toISOString(),
          metadata: {
            pageUrl: window.location.href,
            deviceType: navigator.userAgent.includes('Mobile')
              ? 'mobile'
              : 'desktop'
          }
        }

        await axios.post('/api/track-events', event, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
      } catch (error) {
        console.error('Failed to track navigation event:', error)
      }
    },
    [isLocalhost]
  )

  return {
    trackOpen: () => trackNavigationEvent('OPEN'),
    trackClose: () => trackNavigationEvent('CLOSE'),
    trackClick: (linkName: string) => trackNavigationEvent('CLICK', linkName)
  }
}
